import EmptyResult from "./EmptyResultsModal";
export default EmptyResult;
